import { precacheAndRoute, precache, cleanupOutdatedCaches } from 'workbox-precaching';

//Init precache
precacheAndRoute([]);
cleanupOutdatedCaches();

let wasCaching = false;
let chunksToCache = self.__WB_MANIFEST.map(chunk => chunk);

//Import workers
const ImportWorkers = [
    // wyłączam cache z powodu problemów z INP
    // import('./ArticleCache/ArticleCacheWorker')
];

self.addEventListener("install", async () => {
    //skipWaiting: true
    self.skipWaiting()

    //Load additional workers
    for (let importWorker of ImportWorkers) {
        const { default: worker } = await importWorker;
        worker(self);
    }
});

//clientsClaim: true
self.addEventListener('activate', () => self.clients.claim());

//web push taboola
importScripts("https://cdn.taboola.com/webpush/tsw.js");